import {useRcfaCompliance} from '@domain/rcfa'
import {PlantViewOption, PlantViewOptions} from '@hconnect/common/consts'
import {DataContentWrapper} from '@hconnect/common/containers'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Box} from '@mui/material'
import {useMemo} from 'react'

import {RcfaComplianceHierarchyTable, RcfaCompliancePlantList} from '../components'
import {
  convertToLocationNodes,
  mapToRcfaComplianceHierarchyTable,
  mapToRcfaCompliancePlantList,
  rcfaComplianceTimeRangeMapper
} from '../mappers'

type Props = {
  plantView: PlantViewOption
  timeRange: string
  timezone: string
  onPlantItemClick: (plantId: string) => void
  getIsExpanded: (id: string) => boolean
  toggleExpandCollapse: (id: string) => void
}

export const RcfaComplianceContainer = (props: Props) => {
  const {timeRange, timezone, plantView} = props

  const {from, to} = rcfaComplianceTimeRangeMapper(timezone, timeRange)

  const {data, isLoading, isError, isRefetching, refetch} = useRcfaCompliance(
    {
      from,
      to
    },
    {select: convertToLocationNodes}
  )
  const hierarchyTableData = useMemo(() => mapToRcfaComplianceHierarchyTable(data ?? []), [data])
  const plantListData = useMemo(() => mapToRcfaCompliancePlantList(data ?? []), [data])

  return (
    <CardBox sx={{flex: 1, width: '100%'}}>
      <DataContentWrapper
        data={data}
        showLoader={isLoading}
        isError={isError}
        isRefetching={isRefetching}
        retryFunction={refetch}
        progressSx={{color: 'primary.main'}}
      >
        <Box display={plantView === PlantViewOptions.PLANT_LIST ? 'initial' : 'none'}>
          <RcfaCompliancePlantList data={plantListData} onPlantItemClick={props.onPlantItemClick} />
        </Box>
        <Box display={plantView === PlantViewOptions.REGIONAL_STRUCTURE ? 'initial' : 'none'}>
          <RcfaComplianceHierarchyTable
            data={hierarchyTableData}
            getIsExpanded={props.getIsExpanded}
            toggleExpandCollapse={props.toggleExpandCollapse}
            onPlantItemClick={props.onPlantItemClick}
          />
        </Box>
      </DataContentWrapper>
    </CardBox>
  )
}
